// Eğitim Raporları (/education-reports). Roller ve doküman adları kayıtlı
// değerlerdir; Excel dosyası Türkçe kalır.
const educationReports = {
  page: {
    title: 'Eğitim Raporları',
    subtitle: 'Çalışanların rolüne atanan SOP’leri ve eğitimleri ne kadar tamamladığı (gerçek okuma onayları ve izleme kayıtlarından).',
  },
  actions: {
    excel: 'Tabloyu İndir',
    excelHint: 'Tüm çalışanların SOP ve eğitim durumunu Excel olarak indir',
  },
  stats: {
    assigned: 'Atanan SOP / Eğitim',
    assignedShort: 'Atanan',
    done: 'Tamamlanan',
    doneShort: 'Tamamlanan',
    pending: 'Bekleyen',
    pendingShort: 'Bekleyen',
    overdue: 'Son Tarihi Geçen',
    overdueShort: 'Geciken',
    share: 'Atananların %{{percent}}’i',
  },
  scope: {
    label: 'Kapsam',
    all: 'SOP + Eğitim',
    SOP: 'Yalnız SOP',
    'Eğitim': 'Yalnız eğitim',
  },
  toolbar: {
    search: 'Ad, soyad veya rol ile ara…',
    searchShort: 'Çalışan ara…',
    status: 'Tamamlama durumu',
    all: 'Tümü',
    overdue: 'Gecikmesi olanlar',
    overdueHint: 'Son tarihi geçmiş, tamamlanmamış ataması olan çalışanlar',
  },
  status: {
    completed: 'Tamamlandı',
    inProgress: 'Devam Ediyor',
    notStarted: 'Başlanmadı',
  },
  types: {
    sop: 'SOP',
    training: 'Eğitim',
  },
  deadline: {
    late: '{{days}} gün gecikti',
    today: 'Bugün son gün',
    left: '{{days}} gün kaldı',
  },
  columns: {
    name: 'Çalışan',
    role: 'Rol',
    progress: 'İlerleme',
    status: 'Durum',
    sop: 'SOP',
    training: 'Eğitim',
    overdue: 'Gecikmiş',
    email: 'E-posta',
    project: 'Proje',
    department: 'Departman',
  },
  table: {
    listLabel: 'Çalışanların eğitim durumu',
    empty: 'Filtrelere uygun eğitim kaydı bulunamadı',
    rangeOf: '/ {{total}} çalışan',
    ofTotal: 'toplam {{total}} çalışan içinden',
    jump: 'Sayfaya git',
    noRole: 'Rol atanmamış',
    progress: '{{done}}/{{total}}',
  },
  panel: {
    label: 'Seçili çalışan',
    heading: 'Eğitim durumu',
    pending: 'Bekleyenler',
    completed: 'Tamamlananlar',
    allDone: 'Atanan her şey tamamlandı.',
    noneDone: 'Henüz tamamlanan yok.',
    role: 'Rol',
    department: 'Departman',
    projects: 'Projeler',
    email: 'E-posta',
    summary: '{{done}} / {{total}} tamamlandı',
    version: 'v{{version}}',
  },
  // Eğitim Yönetimi (/education-management): SMO'nun merkezlerindeki çalışanlar
  smo: {
    title: 'Eğitim Yönetimi',
    subtitle: 'SMO: {{name}} · Sorumlu olduğunuz merkezlerdeki çalışanların SOP ve eğitim durumu.',
    excelHint: 'Merkezlerinizdeki çalışanların SOP ve eğitim durumunu Excel olarak indir',
    search: 'Ad, soyad, departman, rol veya proje ile ara…',
    yourCenters: 'Merkezleriniz:',
    note: 'Sorumlu olduğunuz merkezlerden birindeki bir projede çalışan aktif çalışanlar listelenir. SOP, okuma onayı (sınav geçildikten sonra) verildiğinde; eğitim, videonun en az %50’si izlendiğinde tamamlanmış sayılır.',
    noCenters: 'SMO olarak atandığınız merkez bulunamadı',
    stats: {
      centers: 'Atandığınız Merkez',
      centersShort: 'Merkez',
      people: 'Bu Merkezlerdeki Çalışan',
      peopleShort: 'Çalışan',
      done: 'Tamamlanan / Atanan',
    },
  },
  note: 'SOP, okuma onayı (sınav geçildikten sonra) verildiğinde; eğitim, videonun en az %50’si izlendiğinde tamamlanmış sayılır. Yalnızca aktif çalışanlar listelenir.',
  toast: {
    loadError: 'Eğitim raporu yüklenirken hata oluştu',
    excelDone: 'Excel dosyası başarıyla indirildi',
    excelError: 'Dosya indirilirken hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default educationReports;
